import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap";
import { ServerRequestProtected, ServerRequestPublic } from "../../../utils/ServerDataRequest";
import NotificationHandler from "../../../utils/NotificationHandler";
import { saveAs } from "file-saver";
import { enumUtil } from "../../../utils/Enum";
import Loader from "../../shared/Loader/Loader";
import isNull from "../../../utils/NullChecking";
import { useSelector } from "react-redux";
import handleNumericCheck from "../../../utils/HandleNumericKeys";
import { FindSecondChild } from "../../../utils/FindMenuOption";
import { useKeyboardShortcut } from "../../../utils/useKeyboardShortcut";

const SearchHeader = (props) => {
    const { AddNew, Excel, PDF, Delete, Filter, cardView, tableView, searchButton, show, handleSubMenu, isSubmenuOpen, component, AddNewClaims, AddNewIntitutionalClaim, AddNewDental, AddNewInsurance, AddNewPatient, Key, Name, masterListButton, showRecentRecord, FilterClass, Counts, tableName, searchParam, Model, AddNewBulkClaims, clearHouseButton, isEmpty, showRecentRecordButton, PerPage, PageNo, TotalPages, gridSettings, componentColumns, ColumnTableName } = { ...props }
    const API_ExcelExport = enumUtil.controller.ExcelExport;
    const API_URL = enumUtil.controller.General
    let IsAddAllowedInsurancePayment = FindSecondChild('Billing', 'Payments', 'Payments')?.IsAdd
    let IsAddAllowedPatientPayment = FindSecondChild('Billing', 'Payments', 'Patient Payment')?.IsAdd
    const [isLoading, setIsLoading] = useState(false);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    const [isExport, setIsExport] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    // const [PerPage, setPerPage] = useState(10);
    // const [PageNo, setPageNo] = useState(1);
    useEffect(() => {
        // click anywhere on screeen menu will be closed 
        document.querySelector('.layout').addEventListener('click', () => {
            document.querySelectorAll('.hk-plusWrapper').forEach((eve) => {
                if (eve.classList.value.includes('active-submenu')) {
                    eve.classList.remove('active-submenu');
                }
            })
        })
    }, [])
    const handleFindGridSettings = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.GridSettings,
            "SearchParam": props.ColumnTableName
        }).then((response) => {
            setIsLoading(false)
            // setColumnID(response.GridsettingsID + "")
            const array = response.ColumnNames.split(', ');
            setColumnNames(array)
            // setVisibleColumns(array)
            // setCopyCols(array)
        }).catch((error) => {
            const allKeys = componentColumns.map(col => col.key);
            setSelectedItems(allKeys);
            setIsLoading(false)
            // setVisibleColumns(props.columns.map(col => col.key))
            // setCopyCols(props.columns.map(col => col.key))
        })
    }
    const [selectedOption, setSelectedOption] = useState("allPages");
    const [pageRange, setPageRange] = useState({ startPage: "", EndPage: "" });
    const handleRadioChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleOpenExport = () => {
        if (!isEmpty) {
            NotificationHandler('No Data Found!', enumUtil.enumtoaster.error);
        }
        else {
            setIsExport(true)
        }
    }
    useEffect(() => {
        if (isExport) {
            handleFindGridSettings();
        }
    }, [isExport]);  // Dependency remains isExport
    const [selectedItems, setSelectedItems] = useState([]); // default fallback
    const [showAll, setShowAll] = useState(false);
    useEffect(() => {
        if (!columnNames.length) {
            setSelectedItems([]);
            return;
        }
        // const commonValues = componentColumns?.filter(value => columnNames.includes(value.key))
        const commonKeys = componentColumns
            ?.filter(value => columnNames.includes(value.key))
            .map(item => item.key);


        if (commonKeys?.length) {
            setSelectedItems(commonKeys);
        }
        else if (componentColumns?.length) {
            const allKeys = componentColumns.map(col => col.key);
            setSelectedItems(allKeys);
        }
    }, [componentColumns, columnNames]);
    const handleClose = () => {
        setIsExport(false)
        setSelectedItems([])
        setPageRange({ ...pageRange, startPage: "", EndPage: "" });
    }
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setPageRange((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter(i => i !== item));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };
    const handleDownloadexexl = (searchParam) => {
        let payload = {}
        if (selectedOption === "currentPage") {
            let requestData = {
                "TableName": tableName,
                "SearchCriteria": searchParam,
                "SelectiveColumn": selectedItems.join(","),

                "PerPage": PerPage,
                "PageNo": PageNo,
            };
            payload = requestData
        }
        else if (selectedOption === "allPages") {
            let requestData = {
                "TableName": tableName,
                "SearchCriteria": searchParam,
                "SelectiveColumn": selectedItems.join(","),

                // "PerPage": requestData.PerPage,
                // "PageNo": requestData.PageNo,
            };
            payload = requestData
        }
        else if (selectedOption === "pageRange") {
            let requestData = {
                "TableName": tableName,
                "SearchCriteria": { ...searchParam, EndPage: pageRange?.EndPage },
                "SelectiveColumn": selectedItems.join(","),
                "PerPage": PerPage,
                "PageNo": pageRange?.startPage,
            };
            payload = requestData

        }

        if (selectedOption === "") {
            NotificationHandler('Please select Option', enumUtil.enumtoaster.warning);
        }
        else {
            if (selectedOption === "pageRange") {
                if (pageRange?.EndPage < pageRange.startPage) {
                    NotificationHandler('Starting page is grater then End page', enumUtil.enumtoaster.warning);
                }
                else {
                    setIsLoading(true);
                    ServerRequestPublic(API_ExcelExport + "/ExportExcelList", 'post', payload, "Download")
                        .then((response) => {
                            setIsLoading(false);
                            let blob = new Blob([response]);
                            saveAs(blob, Name + '.xlsx');
                            // setIsExport(false)
                            handleClose();
                            setSelectedOption('allPages')
                        }).catch((error) => {
                            setIsLoading(false);
                            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                        });
                }
            }
            else {
                setIsLoading(true);
                ServerRequestPublic(API_ExcelExport + "/ExportExcelList", 'post', payload, "Download")
                    .then((response) => {
                        setIsLoading(false);
                        let blob = new Blob([response]);
                        saveAs(blob, Name + '.xlsx');
                        setIsExport(false)
                        setSelectedOption('allPages')
                    }).catch((error) => {
                        setIsLoading(false);
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                    });
            }

        }



    }
    //    const handleFindGridSettings = () => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL + "/FindByID", 'post', {
    //         "TableName": enumUtil.enumAPITableName.GridSettings,
    //         "SearchParam": props.TableName
    //     }).then((response) => {
    //         setIsLoading(false)
    //         setColumnID(response.GridsettingsID + "")
    //         setColumnNames(response.ColumnNames)
    //         const array = response.ColumnNames.split(', ');
    //         setVisibleColumns(array)
    //         setCopyCols(array)
    //     }).catch((error) => {
    //         setIsLoading(false)
    //         setVisibleColumns(props.columns.map(col => col.key))
    //         setCopyCols(props.columns.map(col => col.key))

    //     })
    // }
    const divOpenSubOpenMenu = component === 'Claims' ?
        <div className="hk-plusWrapper__submenu">
            <div className="hk-plusWrapper__submenu__item" onClick={AddNewClaims}>
                <div className="wrap d-flex align-items-center heading">
                    <i className="icon-plus-icon" ></i>Add Professional
                </div>
            </div>
            <div className="hk-plusWrapper__submenu__item" onClick={AddNewIntitutionalClaim}>
                <div className="wrap d-flex align-items-center heading">
                    <i className="icon-plus-icon"></i>Add Institutional
                </div>
            </div>
            <div className="hk-plusWrapper__submenu__item" onClick={AddNewDental}>
                <div className="wrap d-flex align-items-center heading">
                    <i className="icon-plus-icon"></i>Add Dental
                </div>
            </div>
        </div> :
        component === 'Payments' ?
            <div className="hk-plusWrapper__submenu">
                <div className={`hk-plusWrapper__submenu__item ${IsAddAllowedInsurancePayment ? '' : 'disable'}`} onClick={() => AddNewInsurance()}>
                    <div className="wrap d-flex align-items-center heading">
                        <i className="icon-plus-icon"></i>Add Insurance Payment
                    </div>
                </div>
                {isHomeCareCheck === 'true' ? null :
                    <div className={`hk-plusWrapper__submenu__item ${IsAddAllowedPatientPayment ? '' : 'disable'}`} onClick={() => AddNewPatient()}>
                        <div className="wrap d-flex align-items-center heading">
                            <i className="icon-plus-icon"></i>Add Patient Payment
                        </div>
                    </div>}
            </div> :
            component === 'Agency Claims' ?
                <div className="hk-plusWrapper__submenu">
                    <div className="hk-plusWrapper__submenu__item" onClick={AddNewClaims}>
                        <div className="wrap d-flex align-items-center heading">
                            <i className="icon-plus-icon"></i>Add Claim
                        </div>
                    </div>
                    <div className="hk-plusWrapper__submenu__item" onClick={AddNewBulkClaims}>
                        <div className="wrap d-flex align-items-center heading">
                            <i className="icon-plus-icon"></i>Add Bulk Claim
                        </div>
                    </div>
                </div> :
                <></>;


    useKeyboardShortcut("e+e", handleOpenExport, 300, props.enabled);


    return (
        <>
            {isLoading && <Loader />}
            <div className={`d-flex justify-content-between align-items-center search-header  ${show ? '' : 'me-4'}`}>
                <span className="text ar-found-text fw-400 fst-italic">{Counts ? Counts + ' Record(s) Found' : null} </span>

                <div className='d-flex justify-content-end gap-2'>

                    {searchButton != null && searchButton.AddNew === true ? searchButton.AddNewSubmenu ?
                        <div className={`hk-plusWrapper ${isSubmenuOpen && 'active-submenu'}`}>
                            <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn" onClick={handleSubMenu}>
                                <i className="fs-15 icon-plus-icon"></i>
                            </button>
                            {divOpenSubOpenMenu}
                        </div>
                        : <>
                            {searchButton != null && searchButton.clearHouseButton === true ?
                                <>
                                    <button className="btn btn-validate px-2 rounded" onClick={() => clearHouseButton()} >Integrated Clearinghouses </button>
                                </> : null
                            }
                            {searchButton != null && searchButton.masterListButton === true ?
                                <>
                                    {showRecentRecordButton === false ? null : <button class="btn btn-orange btn-xs no-width rounded mb-0 master_list" onClick={() => showRecentRecord()} >Show Recents Records </button>}
                                    <button class="btn btn-orange btn-xs no-width rounded mb-0 master_list" onClick={() => masterListButton()}>Master List</button> </> :
                                null}
                            <button className='btn-icon-circle btn-xs app_tooltip bottom' onClick={() => AddNew(null)}>
                                <i className="fs-15 icon-plus-icon"></i>
                                <p class="tool_tip xsm_text text-light">Add</p>
                            </button>
                        </>
                        : null}
                    {searchButton != null && searchButton.Excel === true ? <button className={`btn-icon-transparent text-success ${searchButton.AddNew ? 'filter_icon' : ''} `} onClick={handleOpenExport}>
                        {/* onClick={() => handleDownloadexexl(searchParam)} */}
                        <div className="app_tooltip bottom">
                            <i className="icon-excel"></i>
                            <p class="tool_tip xsm_text text-light">Export Excel</p>
                        </div>
                    </button> : null}
                    {/* {searchButton != null && searchButton.PDF === true ? <button className='btn-icon-transparent text-danger  filter_icon' onClick={PDF}>
                        <div className="app_tooltip bottom">
                            <i className="icon-pdf"></i>
                            <p class="tool_tip xsm_text text-light">Export Pdf</p>
                        </div>
                    </button> : null} */}
                    {searchButton != null && searchButton.AddNew != null && searchButton.Delete === true ? <button className='btn-icon-transparent' onClick={Delete}><i className="icon-delete"></i></button> : null}
                    {searchButton != null && searchButton.Filter === true ? <button className='btn-icon-transparent filter_icon' onClick={Filter}>
                        <div className="app_tooltip left me-2">
                            <i className={`icon-filter1 ${FilterClass === true ? 'filter-filled' : ''}`}></i>
                            <p class="tool_tip xsm_text text-light">Filter</p>
                        </div>
                    </button> : null}
                    {searchButton != null && searchButton.View === true ? <>
                        <button className={show ? 'btn-icon-transparent filter_icon active' : 'btn-icon-transparent filter_icon'} onClick={cardView}>
                            <div className="app_tooltip bottom">
                                <i className="icon-card-view"></i>
                                <p class="tool_tip xsm_text text-light">Card View</p>
                            </div>
                        </button>
                        <button className={show ? 'btn-icon-transparent filter_icon' : 'btn-icon-transparent filter_icon active'} onClick={tableView}>
                            <div className="app_tooltip left">
                                <i className="icon-table-view"></i>
                                <p class="tool_tip xsm_text text-light">List View</p>
                            </div>
                        </button>
                    </> : null
                    }
                    {/* { searchButton !=null &&  searchButton.View === false ? <>
                  <button className='btn-icon-transparent active'><i className="icon-table-view"></i></button> 
            </>: null
          } */}
                </div>
            </div>

            <Modal show={isExport} onHide={handleClose} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_export-excel_popup">
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-between mb-12">
                        <div className="">
                            <p className="heading dark-clr fs-13">Export Records to Excel</p>
                            <p className="text dark-clr fs-13">Select the range of data you want to export</p>
                        </div>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={handleClose}></i>
                    </div>
                    <div className="d-flex flex-column gap-12">
                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                            <input
                                type="radio"
                                id="allPages"
                                name="exportOption"
                                value="allPages"
                                checked={selectedOption === "allPages"}
                                onChange={handleRadioChange}
                            />
                            <p className="text ar-orange-text" htmlFor="Claim">All Pages ({PageNo} - {TotalPages})</p>
                        </div>
                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                            <input
                                type="radio"
                                id="currentPage"
                                name="exportOption"
                                value="currentPage"
                                checked={selectedOption === "currentPage"}
                                onChange={handleRadioChange}
                            />
                            <p className="text ar-orange-text" htmlFor="Claim">Current Page ({PageNo})</p>
                        </div>
                        <div className="d-flex align-items-center gap-10">
                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                <input
                                    type="radio"
                                    id="pageRange"
                                    name="exportOption"
                                    value="pageRange"
                                    checked={selectedOption === "pageRange"}
                                    onChange={handleRadioChange}
                                />
                                <p className="text ar-orange-text" htmlFor="Claim">Page Range</p>
                            </div>
                            <div className="d-flex align-items-center gap-2 range-input">
                                <div className="input mb-0">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="startPage"
                                        id="startPage"
                                        value={pageRange.startPage}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                        onChange={handleInputChange}
                                        disabled={selectedOption !== "pageRange"}
                                    />
                                </div>
                                <p className="text">to</p>
                                <div className="input mb-0">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="EndPage"
                                        id="EndPage"
                                        value={pageRange.EndPage}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                        onChange={handleInputChange}
                                        disabled={selectedOption !== "pageRange"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="select-column-box d-flex flex-column gap-2 position-relative">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className='text ar-light-color lh-12'>Select Columns</p>
                                {/* <p className='text fs-11 font-m validate-color lh-12'>Select All</p> */}
                            </div>
                            <div className="d-flex align-items-center flex-wrap row-gap-10 ar_options">
                                {(showAll ? componentColumns : componentColumns?.slice(0, 6))?.map((item, index) => (
                                    <label key={index} className="d-flex align-items-center gap-2">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name={item?.key}
                                                id={item?.key}
                                                checked={selectedItems?.includes(item?.key)}
                                                onChange={() => handleCheckboxChange(item?.key)}
                                            />
                                        </div>
                                        <p className="text fs-12">{item?.headerName}</p>
                                    </label>
                                ))}
                            </div>
                            <div className="see-all-btn d-flex align-items-center gap-1 w-fit-content cursor-pointer user-select-none" onClick={() => setShowAll(!showAll)}>
                                <i className="icon-down fs-7 pt-2px"></i>
                                <p className="text fs-10 font-m text-white lh-10" > {showAll ? 'See Less Columns' : 'See All Columns'}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClose}>Cancel</button>
                    <button className='btn btn-validate px-10 h-100' onClick={() => handleDownloadexexl(searchParam)}>Export</button>
                </div>
            </Modal>
        </>
    )
}
export default React.memo(SearchHeader)